import * as React from "react";
import Categories from "./Categories";

/** Unpublished / not-live-on-storefront collections (same tree UI as Categories). */
export default function UnpublishedCategories() {
  return <Categories mode="unpublished" />;
}
